"use client";

import { useLanguage } from "@/contexts/language-context";

export function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="py-12 border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-black">
      <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between items-center">
        <div className="flex items-center gap-2 mb-4 md:mb-0">
          <div className="w-6 h-6 bg-gray-900 dark:bg-white rounded-md"></div>
          <span className="font-bold text-gray-900 dark:text-white">에스알컴즈 (SRComs)</span>
        </div>
        <p className="text-gray-500 text-sm">{t.footer.rights}</p>
      </div>
    </footer>
  );
}
